<ipo-input
  class="input"
  [placeholder]="'table.searchPlacerholder' | translate"
  [label]="'Sök projekt'"
  [showSearchAndClearIcons]="true"
  (changed)="handleSearch($event)"
></ipo-input>
